import { createLink, getLinkDetails } from 'lib/experiencePlayer/api'
import {
  LOCAL_STORAGE_KEY,
  DEFAULT_TTL_SECONDS,
} from 'lib/experiencePlayer/constants'
import { actions } from './reducer'

function saveToLocalStorage(linkData) {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(linkData))
  } catch {
    // localStorage may be unavailable
  }
}

function clearLocalStorage() {
  try {
    localStorage.removeItem(LOCAL_STORAGE_KEY)
  } catch {
    // localStorage may be unavailable
  }
}

export function loadFromLocalStorage() {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

function createLinkForLesson({ lessonId, ttlSeconds = DEFAULT_TTL_SECONDS }) {
  return async dispatch => {
    dispatch(actions.creatingLink())
    try {
      const response = await createLink({
        lessonId,
        ttlSeconds,
      })

      const linkData = {
        linkId: response.linkId,
        url: response.url,
        expiresAt: response.expiresAt,
        hasPassword: response.hasPassword,
        lessonId,
        isValid: true,
      }

      dispatch(actions.createLinkSuccess(linkData))
      saveToLocalStorage(linkData)

      return linkData
    } catch (error) {
      dispatch(
        actions.createLinkError(error.message || 'Failed to create link'),
      )
      throw error
    }
  }
}

function checkLinkStatus({ linkId }) {
  return async dispatch => {
    try {
      const response = await getLinkDetails({ linkId })

      const linkData = {
        linkId: response.linkId,
        url: response.url,
        expiresAt: response.expiresAt,
        hasPassword: response.hasPassword,
        lessonId: response.lessonId,
        isValid: response.isValid,
      }

      if (!response.isValid) {
        dispatch(actions.clearLink())
        clearLocalStorage()
        return null
      }

      dispatch(actions.updateLinkStatus(linkData))
      saveToLocalStorage(linkData)
      return linkData
    } catch (error) {
      if (error.statusCode === 404) {
        dispatch(actions.clearLink())
        clearLocalStorage()
        return null
      }
      dispatch(actions.setError(error.message || 'Failed to check link status'))
      return null
    }
  }
}

function hydrateFromLocalStorage({ lessonId }) {
  return dispatch => {
    const stored = loadFromLocalStorage()
    if (stored && stored.lessonId === lessonId) {
      dispatch(actions.updateLinkStatus(stored))
      return stored
    }
    return null
  }
}

export default {
  createLinkForLesson,
  checkLinkStatus,
  hydrateFromLocalStorage,
}
